import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconProfile = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M16 16h-2a3 3 0 00-3-3H5a3 3 0 00-3 3H0a5 5 0 015-5h6a5 5 0 015 5zm-8-6A5 5 0 017.17.07a5 5 0 111.66 9.86A4.76 4.76 0 018 10zm-.5-8A3 3 0 005 5.5 3 3 0 008.5 8a3 3 0 10-1-6z' />
        </svg>
    );
};

IconProfile.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconProfile.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconProfile;
